import { RestUserFeed } from '../schema-copy/api-schema';

// Comparison key for feed URLs, mirroring the server's normalizeAliasUrl: case-insensitive, scheme
// and trailing slashes ignored. Returns undefined for anything that isn't an http(s) URL.
export function feedUrlKey(url: string): string | undefined {
  const m = url.trim().toLowerCase().match(/^https?:\/\/(.+?)\/*$/);
  return m?.[1];
}

// The followed feed whose URL matches `url`, if any. Resolving locally first costs no request and
// also finds the user's PRIVATE feeds, which the public by-URL lookup never returns.
export function findFollowedFeedByUrl(feeds: RestUserFeed[], url: string): RestUserFeed | undefined {
  const key = feedUrlKey(url);
  return key ? feeds.find(f => f.url && feedUrlKey(f.url) == key) : undefined;
}
